import { setAlpha } from '@talos/kyoko';
import { FUNDING_RATE_HEAT_MAX_ALPHA, FUNDING_RATE_HEAT_MIN_ALPHA } from './tokens';

/**
 * Opacity for a Matrix heat chip, scaled by the rate's magnitude relative to the largest |rate| in
 * the current snapshot (adaptive normalization — the strongest cell in view is fully saturated).
 * Floored at MIN_ALPHA so small non-zero rates stay visible and capped at MAX_ALPHA so the strongest
 * cell isn't a harsh solid fill. Returns the floor when there's no positive reference magnitude.
 * Exported for unit testing.
 */
export function fundingRateHeatAlpha(ratePct: number, maxAbsRate: number): number {
  if (!(maxAbsRate > 0)) {
    return FUNDING_RATE_HEAT_MIN_ALPHA;
  }
  const ratio = Math.min(Math.abs(ratePct) / maxAbsRate, 1);
  return FUNDING_RATE_HEAT_MIN_ALPHA + ratio * (FUNDING_RATE_HEAT_MAX_ALPHA - FUNDING_RATE_HEAT_MIN_ALPHA);
}

/**
 * Background color for a Matrix heat chip: the positive (green) base for a rate ≥ 0, the negative
 * (red) base otherwise, at a magnitude-scaled opacity. Callers pass the resolved theme base colors.
 */
export function fundingRateHeatColor(
  ratePct: number,
  maxAbsRate: number,
  positiveColor: string,
  negativeColor: string
): string {
  const base = ratePct >= 0 ? positiveColor : negativeColor;
  return setAlpha(fundingRateHeatAlpha(ratePct, maxAbsRate), base);
}
